<template>
  <div
    class="flex flex-col cursor-pointer"
    @click="navigateToBuiltInstance"
  >
    <div class="text-sm">
      {{ formatHelper.readableDate(instance.created_at) }}
    </div>
    <base-card class="flex flex-1">
      <base-card-body class="w-full">
        <div class="flex items-start">
          <img
            alt="Survey"
            width="30"
            src="@/assets/icons/survey.svg"
            class="cursor-pointer mr-5"
          >
          <div class="flex-1">
            <strong>{{ instance.survey.name }}</strong>
            <div
              v-if="instance.verdict"
              class="flex flex-row items-start my"
            >
              <img
                alt="Verdict"
                src="@/assets/images/verdict-chevrons.png"
                class="mr-3 w-8 object-contain"
              >
              <p class="text-sm">
                {{ instance.verdict.title }}
              </p>
            </div>
          </div>
          <div
            class="w-8 shrink-0"
            @click.stop
          >
            <CustomerSurveyCardPopoverMenu
              :instance="answerInstance"
              @open="navigateToBuiltInstance"
              @deleted="$emit('deleted')"
            />
          </div>
        </div>
      </base-card-body>
    </base-card>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import BaseCard from '@/core/components/base/BaseCard.vue';
import formatHelper from '@/core/helpers/formatHelper';
import BaseCardBody from '@/core/components/base/BaseCardBody.vue';
import CustomerSurveyCardPopoverMenu from "@/customer/components/customer-surveys/CustomerSurveyCardPopoverMenu.vue";
import {SurveyAnswerInstanceIndex} from "@/core/interfaces/survey/Survey";

export default defineComponent({
    name: 'CustomerSurveyCard',
    components: { BaseCardBody, BaseCard, CustomerSurveyCardPopoverMenu },
    props: {
        instance: {
            type: Object,
            required: true
        }
    },
    emits: ['deleted'],
    computed: {
        formatHelper () {
            return formatHelper;
        },
        answerInstance (): SurveyAnswerInstanceIndex {
            return this.instance as SurveyAnswerInstanceIndex;
        }
    },
    methods: {
        navigateToBuiltInstance () {
            this.$router.push({
                name: 'customer.survey',
                params: { instanceId: this.instance.id, verdict: this.instance.verdict }
            });
        }
    }
});
</script>
